module.exports = __webpack_public_path__ + "img/TaxServiceLOGO.4657b04a.png";